import {
  isMonetaryAuthorityQuotesFeatureEnabled,
  isMonetaryAuthoritySettlementFeatureEnabled,
} from "@/config/runtimeConfig";

export const LEGACY_MONETARY_BOUNDARY_ERROR_CODE =
  "monetary/private-authority-required";

const LEGACY_MONETARY_BOUNDARY_MESSAGE =
  "Unit payments are temporarily unavailable while secure payments are being activated.";

export class LegacyMonetaryBoundaryError extends Error {
  constructor() {
    super(LEGACY_MONETARY_BOUNDARY_MESSAGE);
    this.name = "LegacyMonetaryBoundaryError";
    this.code = LEGACY_MONETARY_BOUNDARY_ERROR_CODE;
  }
}
export function isPrivateMonetaryBoundaryEnabled(
  quotesEnabled = isMonetaryAuthorityQuotesFeatureEnabled,
  settlementEnabled = isMonetaryAuthoritySettlementFeatureEnabled,
) {
  return quotesEnabled === true || settlementEnabled === true;
}

/**
 * Legacy monetary readers, calculations and mutations are one indivisible
 * browser-authority boundary. Selecting either private quote or settlement
 * authority must therefore disable all of them; a mixed private/legacy path
 * could otherwise quote from canonical state and settle browser-owned values.
 */
export function assertLegacyMonetaryClientAvailable(
  quotesEnabled = isMonetaryAuthorityQuotesFeatureEnabled,
  settlementEnabled = isMonetaryAuthoritySettlementFeatureEnabled,
  legacyClientExplicitlyEnabled = false,
) {
  // Browser-owned balances, exchange rates, recipients and side effects are
  // not an acceptable fallback while the private authority is disabled. The
  // third argument exists only for isolated legacy tests and local migration
  // tooling; application callsites intentionally never opt in.
  if (
    legacyClientExplicitlyEnabled !== true ||
    isPrivateMonetaryBoundaryEnabled(quotesEnabled, settlementEnabled)
  ) {
    throw new LegacyMonetaryBoundaryError();
  }
}
